export default __webpack_public_path__ + "static/media/logo.8184c79e.svg";